import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {collection, deleteDoc, doc, getDocs, orderBy, query, where,} from "firebase/firestore";
import {Badge, Button, Card, CardBody, CardHeader, Col, Collapse, Spinner,} from "reactstrap";
import {deleteObject, getStorage, ref} from "firebase/storage";

import {getDb} from "../../util/Constants";

export const RESPONSE_ENUM = {
    1: "BEST",
    2: "OK",
    3: "WRONG",
};

export const MiniGameCard = (props) => {
    const [miniGameData, setMiniGameData] = useState([]);
    const [loading, setLoading] = useState(null);
    const [toggled, setToggled] = useState(0);
    const [index, setIndex] = useState(0);
    const history = useHistory();
    const { lName } = useParams();
    useEffect(() => {
        fetchMiniGameData();
        return () => {
        };
    }, []);

    const fetchMiniGameData = async () => {

        try {
            setLoading("fetching");
            const questionQuery = query(
                collection(getDb(), "questions"),
                where("miniGame", "==", lName),
                orderBy("createdAt")
            );

            let arr = [];
            const querySnapshot = await getDocs(questionQuery);

            querySnapshot.forEach((doc) => {
                if (doc.data().miniGame === "Mini 1") {
                    arr.push({
                        id: doc.id,
                        question: doc.data().question,
                        options: doc.data().options,
                        templateType: doc.data().miniGameTemplateType,
                        correctAnswer: doc.data().correctAnswer,
                        miniGame: doc.data().miniGame,
                        description: doc.data().description,
                        questionNumber: doc.data().questionNumber,
                        optionsType: "text"
                    });
                } else if (doc.data().miniGame === "Mini 2") {
                    arr.push({
                        id: doc.id,
                        question: doc.data().question,
                        options: doc.data().options,
                        templateType: doc.data().miniGameTemplateType,
                        correctAnswer: doc.data().correctAnswer,
                        miniGame: doc.data().miniGame,
                        template2Type: doc.data().template2Type,
                        description: doc.data().description,
                        questionNumber: doc.data().questionNumber,
                        optionsType: doc.data()?.optionsType ? doc.data().optionsType : "text"

                    });
                }
                else if (doc.data().miniGame === "Mini 3") {
                    arr.push({
                        id: doc.id,
                        question: doc.data().question,
                        miniGame: doc.data().miniGame,
                        questionNumber: doc.data().questionNumber,
                    });

                }
                else if (doc.data().miniGame === "Mini 4") {
                    arr.push({
                        id: doc.id,
                        question: doc.data().question,
                        miniGame: doc.data().miniGame,
                        questionNumber: doc.data().questionNumber,
                        options:doc.data().options
                    });

                }
            });

            if (arr.length > 0) {
                arr.sort(((a, b) => a - b));
                setIndex(arr[arr.length - 1].questionNumber + 1);


            }
            setMiniGameData(arr);
            setLoading("ready");
        } catch (error) {

            setLoading(null);
        }
    };


    useEffect(() => {
    }, [miniGameData])

    const deleteQuestion = async (uid) => {
        try {
            const question = miniGameData.find((e) => e.id === uid)

            setLoading(`deleting${uid}`);
            await deleteDoc(doc(getDb(), "questions", uid)).then((res) => {

                fetchMiniGameData();
                if (question.miniGame === "Mini 2") {
                    deleteStorageQuestion(question);
                    deleteStorageOptions(question)
                }
            });


        } catch (error) {
            alert("delete failed error " + error);
        }

        setLoading(null);
    };

    // `images/Mini2Question${questionIndex}`
    const deleteStorageQuestion = async (question) => {
        const storage = getStorage();
        const desertRef = ref(storage, `images/Mini2Question${question.questionNumber}`);
        deleteObject(desertRef).then(() => {

        }).catch((error) => {

        });
    }

    const deleteStorageOptions = async (question) => {
        const storage = getStorage();
        let index = 0
        for (let item of question.options) {
            index++
            const desertRef = ref(storage, `images/Mini2Question${question.questionNumber}option${index}`);
            deleteObject(desertRef).then(() => {

            }).catch((error) => {

            });
        }
    }





    return (
        <Col lg={8} className="order-lg-0">
            <Card className="shadow mb-3">
                <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                    <h2 className="mb-0">Screens</h2>

                    {(lName === "Mini 2") &&
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {

                                history.push(`/admin/levels/mini-game-add-question/${lName}/${index}`)
                            }}
                        >
                            <i className="fas fa-plus" />
                        </Button>
                    }
                    {
                        lName === "Mini 1" &&
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push(`/admin/levels/mini-game-add-question/${lName}/${index}`)
                            }}
                        >
                            <i className="fas fa-plus" />
                        </Button>
                    }
                    {
                        lName === "Mini 3" &&
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push(`/admin/levels/mini-game-add-question/${lName}/${index}`)
                            }}
                        >
                            <i className="fas fa-plus" />
                        </Button>
                    }
                    {
                        lName === "Mini 4" &&
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                                history.push(`/admin/levels/mini-game-add-question/${lName}/${index}`)
                            }}
                        >
                            <i className="fas fa-plus" />
                        </Button>
                    }



                </CardHeader>
            </Card>

            {miniGameData ? (
                miniGameData.map((element, _number) => (
                    <Card key={_number} className="mb-1 shadow">
                        <CardHeader
                            className="d-flex justify-content-between align-items-center"
                            onClick={() => setToggled(_number)}
                        >
                            <div className="d-flex justify-content-start align-items-center">
                                <p className="mb-0 small">
                                    Screen {_number + 1}{" "}
                                    <span className="ml-2">
                                        <Badge color="primary">
                                            {element.miniGame === "Mini 1" ? "Mini Game Template " + element.templateType : element.template2Type}
                                        </Badge>
                                    </span>
                                </p>
                                <p className="mb-0 small ml-2"></p>
                            </div>
                            <div>
                                {
                                    // lName === "Mini 1" &&
                                    <Button
                                        color="danger"
                                        size="sm"
                                        disabled={loading && loading.startsWith("deleting")}
                                        onClick={(e) => deleteQuestion(element.id)}
                                    >
                                        {loading === `deleting${_number}` ? (
                                            <Spinner color="white" size="sm" />
                                        ) : (
                                            <i className="far fa-trash-alt" />
                                        )}
                                    </Button>
                                }

                                <Button
                                    color="default"
                                    size="sm"
                                    onClick={(e) =>
                                        history.push(
                                            `/admin/levels/mini-game-edit-question/${lName}/${element.id}`
                                        )
                                    }
                                >
                                    <i className="fas fa-pencil-alt" />
                                </Button>
                            </div>
                        </CardHeader>
                        <Collapse isOpen={toggled === _number}>
                            <CardBody className="mt-0">
                                {element.description && (
                                    <div>
                                        <h6>Title</h6>
                                        <p>{element.description}</p>
                                    </div>
                                )}
                                <h6 className="mb-0">{element.miniGame !== "Mini 3"?"Scenario":"Word"}</h6>
                                {element.miniGame === "Mini 4"?<pre>{element.question}</pre>:<p>{element.question}</p>}

                                {element.miniGame !== "Mini 3"? <h6 className="mb-0">{element.miniGame === "Mini 1" ? "Options" : "Options in correct order"}</h6>:""}
                                {/*{element.miniGame==="Mini 1"? "Mini Game Template " + element.templateType:element.template2Type}*/}
                                <ol>
                                    {element.options && element.options.map((answer, i) => (
                                        <li key={i}>
                                            {element.optionsType === "text" ? (
                                                <p className="mb-0">{answer}</p>
                                            ) : (
                                                <img className={"mt-2"} width="100" src={answer} alt={`Option ${i + 1}`} />
                                            )}
                                            <p className="small">
                                                {element.correctAnswer === i && (
                                                    <Badge color="success" className="mr-2">
                                                        Correct Answer
                                                    </Badge>
                                                )}
                                            </p>
                                        </li>
                                    ))}
                                </ol>
                            </CardBody>
                        </Collapse>
                    </Card>
                ))
            ) : (
                <div className="text-center py-5 mt-5">
                    <Spinner color="primary" />
                </div>
            )}
        </Col>
    );
};